import { AnnotationType } from 'types/types'
import { reactive } from 'vue'

import { ANNOTATION_UNDERLINE, FONT_SIZE_CSS_MAP } from '@/constants/annotationConstants'

import { AnnotatedWord } from './AnnotatedWord'
import { AnnotationStyle, parseAnnotationStyle } from './annotationStyle'
import { regularStyle } from './TextStyles'

// Convert semantic annotation style to inline CSS.
// Color properties (color, backgroundColor) pass through directly.
// Other annotations are mapped to their CSS representation:
//   fontSize ('large'/'xlarge') → font-size in em units
//   underline (true) → border-bottom (sits below nikkud, unlike text-decoration)
function characterStyleToCss(style: AnnotationStyle): Record<string, string> {
  const css: Record<string, string> = {}
  if (style.color) {
    css.color = style.color
  }
  if (style.backgroundColor) {
    css.backgroundColor = style.backgroundColor
  }
  if (style.fontSize && FONT_SIZE_CSS_MAP[style.fontSize]) {
    css.fontSize = FONT_SIZE_CSS_MAP[style.fontSize]
  }
  if (style.underline) {
    css.borderBottom = ANNOTATION_UNDERLINE
  }
  return css
}

class AnnotatedCharacter {
  private xword: AnnotatedWord

  private text: string

  private offsetInSentence: number

  public styleClass: string

  public overrideStyle: AnnotationStyle

  constructor(word: AnnotatedWord, offsetInSentence: number, text: string, annotation: AnnotationType | null) {
    this.xword = word
    this.offsetInSentence = offsetInSentence
    this.text = text

    this.styleClass = regularStyle
    // Wrap overrideStyle in reactive() so Vue detects mutations from
    // applyUnderline/applyColor/etc. and re-renders the char span.
    this.overrideStyle = reactive(parseAnnotationStyle(annotation?.style))
  }

  word(): AnnotatedWord {
    return this.xword
  }

  index(): number {
    return this.offsetInSentence
  }

  character(): string {
    return this.text
  }
}

export { AnnotatedCharacter, characterStyleToCss }
